import { AxiosInstance } from 'axios';
import {
    FundsTransferDetailsFilter,
    FundsTransferDetailsTable,
} from 'models/api/fundsTransferDetails';
import ResTable from 'models/api/table';

const controller = '/fundsTransferDetails';

export const getFundsTransferDetailsList = async (
    axios: AxiosInstance,
    params?: FundsTransferDetailsFilter
) => {
    const response = await axios.get<ResTable<FundsTransferDetailsTable>>(controller, { params });
    return response.data;
};

export const getFundsTransferDetailsExcel = async (
    axios: AxiosInstance,
    params: FundsTransferDetailsFilter
) => {
    const { data } = await axios.get<Blob>(controller + '/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const deleteFundsTransferDetails = async (axios: AxiosInstance, id: number | string) =>
    await axios.delete(`${controller}/${id}`);
